<template>
   <div
      class="modal modal-new fade"
      id="change-account"
      tabindex="-1"
      role="dialog"
      aria-labelledby="change-account"
      aria-hidden="true"
   >
      <div class="modal-dialog" role="document">
         <div class="modal-new__content">
            <div class="modal-new__header">
               <span class="modal-new__action" data-bs-dismiss="modal"
                  ><i class="icon-fonts icon-fonts--close"></i
               ></span>
               <h3 class="modal-new__title">{{ $t('home.ftth_utility.link_ftth') }}</h3>
            </div>
            <div class="modal-new__body">
               <div class="change-account">
                  <div class="add-account" @click="redirectTo('/ftth/login')" data-bs-dismiss="modal">
                     <span class="add-account__icon"><i class="icon-fonts icon-fonts--add"></i></span>
                     <h5 class="add-account__name">{{ $t('home.ftth_utility.add_account') }}</h5>
                  </div>
                  <ul class="change-account__list">
                     <li
                        v-for="(item, index) in listAccounts"
                        :key="index"
                        class="change-account__item selected"
                        @click="handleSelectAccount(item.accountNo)"
                     >
                        <span class="change-account__thumbnail"
                           ><span class="change-account__value">{{ item.productCode }}</span></span
                        >
                        <div class="change-account__info">
                           <h5 class="change-account__name">{{ item.custName }}</h5>
                           <p class="change-account__des">{{ item.accountNo }}</p>
                        </div>
                        <span class="change-account__tick"
                           ><i
                              :class="[
                                 { 'icon-fonts': true },
                                 { 'icon-fonts--tick-2': currentAccount == item.accountNo }
                              ]"
                           ></i
                        ></span>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import BaseComponent from '@/mixins/BaseComponent'
import LocalStorage from '@/ultils/local-storage'

export default {
   name: 'ChangeAccountModal',
   mixins: [BaseComponent],
   data() {
      return {
         selectedAccount: ''
      }
   },
   methods: {
      handleSelectAccount(value) {
         this.selectedAccount = value
         this.$emit('selectedAccount', this.selectedAccount)
      },
      redirectTo(url) {
         this.$router.push(url)
      }
   },
   computed: {
      listAccounts() {
         return this.$store.state.linkedFtthAccountList
      },
      currentAccount() {
         let currentAccount = this.selectedAccount || this.$store.state?.linkedFtthAccountList[0]?.account
         let ftthUserInfo = {
            token: '',
            isdn: currentAccount,
            sessionId: ''
         }
         console.log('currentAccount: '+ currentAccount)
         LocalStorage.setItem('ftth_user_info', JSON.stringify(ftthUserInfo))
         LocalStorage.setItem('ftth_account', currentAccount)
         LocalStorage.setItem('ftth_account_info', JSON.stringify(this.$store.state?.linkedFtthAccountList[0]))
         return currentAccount
      }
   }
}
</script>

<style scoped>
.modal-dialog {
   -webkit-transform: none !important;
   transform: none !important;
   top: unset !important;
   position: absolute !important;
   bottom: 0 !important;
   width: 100% !important;
}
</style>
